export const accordionStyles = {
  item:

    "bg-white mb-3 rounded-[12px]",
  header: (isOpen: boolean) =>
    [
      "flex items-center gap-4 w-full  text-left text-xl px-6 py-5 rounded-[12px] cursor-pointer transition-colors justify-start ",
      isOpen
        ? "bg-white-50 text-[#3b4151]"
        : "bg-white text-[#181a20] hover:bg-white-50",
    ].join(" "),
  panel: "px-18 pb-5 text-left text-base text-[#3B4151]",

  buttonIcon:
    "left-4 w-8 h-8 bg-no-repeat bg-center bg-contain transition-all flex items-center justify-center cursor-pointer",

};
